import { LineTab, LineTabs, LineTabsList } from 'components/LineTabs';
import { useIsNewDesign } from 'components/tables/list-table/filter-bar/useIsNewDesign';
import TimecardListWithFilters from 'pages/timecards/TimecardListWithFilters.tsx';
import { useTimecardViews } from 'pages/timecards/useTimecardViews';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
    contactId?: string;
    isInternalContact?: boolean | null;
};

const TimecardView: React.FC<Props> = ({ contactId, isInternalContact }) => {
    const [tabType, setTabType] = useState<'main' | 'draft'>('main');
    const isNew = useIsNewDesign();
    const views = useTimecardViews();

    if (!contactId) {
        return null;
    }

    return (
        <div className="flex h-full flex-col gap-4">
            {/* In the new design the list renders the views row, MAIN and DRAFT included. */}
            {isNew ? null : (
                <LineTabs value={tabType} onValueChange={(value) => setTabType(value === 'draft' ? 'draft' : 'main')}>
                    <LineTabsList>
                        {views.map(({ id, labelId }) => (
                            <LineTab key={id} value={id}>
                                <FormattedMessage id={labelId} />
                            </LineTab>
                        ))}
                    </LineTabsList>
                </LineTabs>
            )}
            <TimecardListWithFilters
                surface="contact"
                tabType={tabType}
                passiveFilters={`matter.clientParty.id=in=(${contactId})`}
                disabledGroups={['timecards.group.client']}
                showTotalsByDefault={!isInternalContact}
            />
        </div>
    );
};

export default TimecardView;
